export { default as AccordionTheme } from './Accordion.style';
